import { DETAILS_PAGE_URL_DISCRIMINATOR_PARAM } from './constants';

export type DetailsParams = {
  detailsDiscriminator: string | null;
  detailsValue?: string | null;
};

export function getDetailsFromSearchParams(searchParams: URLSearchParams) {
  const detailsDiscriminator = searchParams.get(
    DETAILS_PAGE_URL_DISCRIMINATOR_PARAM
  );
  if (detailsDiscriminator == null) {
    return {
      detailsDiscriminator: null,
    };
  }
  const detailsParams = searchParams.getAll(detailsDiscriminator);

  const [detailsValue, detailsLabel] =
    detailsParams.length > 0
      ? [detailsParams.join(','), detailsParams.join(', ')]
      : [null, null];

  return {
    detailsDiscriminator,
    detailsValue,
    detailsLabel,
  };
}
